import React from 'react';

import { ListWithTitle } from '../components/ListWithTitle';
import { Paragraph } from '../components/Paragraph';
import { Subtitle } from '../components/Subtitle';

export const GlintsAdvertisersAndOnlineApplications = () => {
  return (
    <>
      <Subtitle>Glints Advertisers and Online Applications</Subtitle>
      <ListWithTitle
        title={
          <>
            Making an online application to a job advertisement on the Site is a
            free and optional service that requires you to complete mandatory
            fields (for example first name, last name, phone and email) so that
            Advertisers can identify and contact the applicants. When you apply
            for a job advertisement on the Site, applications, including
            attachments and cover letters, are:
          </>
        }
        list={[
          <>
            forwarded directly on to the Advertiser and/or its nominated
            representative; and/or
          </>,
          <>
            stored in the Glints Employers Portal on behalf of the Advertiser.
          </>,
        ]}
      />
      <Paragraph>
        The Glints Employers Portal allows Advertisers to easily and effectively
        manage their recruitment process via one central facility made available
        by Glints.
      </Paragraph>
      <Paragraph>
        By applying to a position advertised on the Site you are requesting that
        Glints pass the information you provide to the relevant Advertiser
        and/or their nominated representative. Any questions you have relating
        to a position advertised on Glints, your online application and/or the
        status of your application should be directed directly to the Advertiser
        or their nominated agent, not Glints.
      </Paragraph>
      <Paragraph>
        Any Personal Information retained by Glints as part of your application
        will only be used in accord with this Privacy Statement. The use of your
        information (personal or otherwise) by Advertisers is not within the
        control of Glints and if you have any questions about how an Advertiser
        uses your personal information or want to request access to any personal
        information that you have sent as part of an application or that has
        been provided to them as part of a Glints Profile (as defined below),
        you have the right to contact that Advertiser directly.
      </Paragraph>
    </>
  );
};
